'use strict';

import React from 'react';
import { values } from 'underscore';
import ContextMenu from '../molecules/ContextMenu';
import StampStore from '../stores/StampStore';
import createStoreMixin from '../mixins/createStoreMixin';
import ShareTypes from '../constants/ShareTypes';
import ShareStampLink from '../atoms/ShareStampLink';
import Link from '../atoms/Link';
import AlertActionCreators from '../actions/AlertActionCreators';
import AlertTypes from '../constants/AlertTypes';
import PureRenderMixin from '../mixins/PureRenderMixin';
import { PropTypes } from 'react';
import getStampSegment from '../utils/getStampSegment';

var StampMoreContextMenu = React.createClass({
  mixins: [createStoreMixin(StampStore), PureRenderMixin],

  propTypes: {
    stampId: PropTypes.number.isRequired,
    anchorRect: PropTypes.object.isRequired,
    showEdit: PropTypes.bool.isRequired,
    shareServices: PropTypes.arrayOf(PropTypes.oneOf(values(ShareTypes)))
  },

  getDefaultProps() {
    return {
      shareServices: []
    };
  },

  getStateFromStores(props) {
    return {
      stamp: StampStore.get(props.stampId)
    };
  },

  render() {
    const stampSegment = getStampSegment(this.state.stamp);

    return (
      <ContextMenu anchorRect={this.props.anchorRect}>
        {this.props.shareServices.map(this.renderShareItem)}

        {this.props.shareServices.length > 0 && this.props.showEdit &&
          <ContextMenu.Separator />
        }

        {this.props.showEdit &&
          <Link propagateClick
                to='stampEditCompose'
                context='ContextMenu'
                underline='never'
                params={{ stampSegment: stampSegment }}>
            Edit Stamp
          </Link>
        }

        {this.props.showEdit &&
          <Link onClick={this.confirmDeleteStamp}
                context='ContextMenu'
                underline='never'
                color='red'>
            Delete Stamp
          </Link>
        }
      </ContextMenu>
    );
  },

  confirmDeleteStamp: function () {
    if (this.props.isPublishing) {
      return;
    }

    AlertActionCreators.showAlert(AlertTypes.DELETE_STAMP, {
      stampId: this.props.stampId
    });
  },

  renderShareItem(service) {
    var stamp = this.state.stamp;

    return (
      <ShareStampLink key={service}
                      propagateClick
                      service={service}
                      stamp={stamp}
                      context='ContextMenu'
                      underline='never' />
    );
  }
});

module.exports = StampMoreContextMenu;



/** WEBPACK FOOTER **
 ** ./contextMenus/StampMoreContextMenu.jsx
 **/